export default {
  title: '文控资料',
  search: {
    placeholder: '搜索标题/产品型号/认证机构'
  },
  columns: {
    countryRegion: '国家/地区',
    title: '标题',
    productCategory: '产品类别',
    certType: '证书类型',
    certProject: '认证项目',
    productModel: '产品型号',
    certOrg: '认证机构',
    effectiveDate: '生效时间',
    expiryDate: '失效时间',
    remark: '备注',
    actions: '操作'
  },
  actions: {
    batchDownload: '下载',
    search: '搜索',
    reset: '重置',
    preview: '预览'
  },
  preview: {
    title: '在线预览'
  },
  messages: {
    noSelection: '请先选择文档',
    loadFailed: '加载文控资料失败',
    downloadFailed: '下载失败',
    downloadSuccess: '下载完成',
    noFile: '所选文档暂无文件',
    tenantOnly: '仅韶音租户可使用文控资料',
    previewFailed: '无法预览',
    previewUnavailable: '无法预览'
  },
  summary: {
    total: '共 {count} 条'
  }
}
